import React, { useEffect } from "react"
import { LegacyFleLayout } from "../../views/atoms/layouts/LegacyFleLayout"
import { Button, FlexContainer, H2, Stack, Text } from "@carrotfertility/carotene"
import { useHistory } from "react-router-dom"
import { Steps } from "./workflow"
import { useBodyClass } from "../../../utils/Hooks"
import { CaseRateRenewalsStatus, useGetCaseRateRenewalStatus } from "./useQueryCaseRateRenewals"
import { FormattedMessage } from "react-intl"

export function GatedExitRoutingFlowWarning() {
  const { data } = useGetCaseRateRenewalStatus()
  const history = useHistory()

  useEffect(() => {
    if (data !== CaseRateRenewalsStatus.GATED) {
      history.push("/")
    }
  })

  useBodyClass("bg-warm-gray")
  return (
    <LegacyFleLayout>
      <H2 stack="tiny">
        <FormattedMessage defaultMessage="Go back to your most recent plan?" />
      </H2>
      <Stack spacing="huge">
        <Text>
          <FormattedMessage defaultMessage="If you go back, we'll ask you to choose either to keep your plan or to get new suggestions." />
        </Text>
        <FlexContainer justifyContent="flex-end" stack="large">
          <Stack spacing="small" direction="row">
            <Button variant="secondary" onClick={() => history.push("/carrot-plans/case-rate-renewal/routing")}>
              <FormattedMessage defaultMessage="Continue with refresh" />
            </Button>
            <Button variant="primary" onClick={() => history.push(`/?step=${Steps.CARROT_PLAN_OPTIONS}`)}>
              <FormattedMessage defaultMessage="Go back to my plan" />
            </Button>
          </Stack>
        </FlexContainer>
      </Stack>
    </LegacyFleLayout>
  )
}
